module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/step4-pict01-7a622da52babda19c9d11997ab657e58.jpg";